import cn from 'classnames'
import Link from 'next/link'
import React from 'react'
interface TooltipModelProps {
  tags?: string[]
  contentTagsLink?: any[] | null
}
const TooltipModel: React.FC<TooltipModelProps> = ({ tags, contentTagsLink }) => {
  const getLink = (linkName: string) => {
    const link = contentTagsLink?.find((item) => item.name === linkName)?.link ?? ''
    return '/' + link
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const getTagBGColour = (linkName: string) => {
    // if (linkName.includes('know-how/')) {
    //   return 'bg-gray-200'
    // }
    // if (linkName.includes('legaltech-resources-for-lawyers/')) {
    //   return 'bg-green-200'
    // }
    // if (linkName.includes('resources-for-solution-providers/')) {
    //   return 'bg-yellow-200'
    // }
    return 'bg-gray-200' // default
  }
  // const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  //   e.preventDefault()
  //   // Removed direct access to e.target.href and console.log to fix lint errors
  //   // If you need to access the href, use e.currentTarget.href
  //   // Example: const href = e.currentTarget.href
  //   //  console.log('=======handleClick=========>>>>>>> clicked TooltipModel >>>', e.currentTarget.href)
  //   window.open(e.currentTarget.href)
  // }

  const randomNum = Math.floor(Math.random() * 1000)
  if (tags && tags.length) {
    return (
      <div className="custom_tooltip insight-cards z-[9999]">
        <div className="tooltip_inner_wrap relative">
          <ul id={randomNum + 'ul'}>
            {tags &&
              tags.map((item, index) => (
                <li key={index + randomNum + item + 'li'} id={index + item + 'li'} title={item + 'li'}>
                  <span
                    key={index + randomNum + 'span'}
                    className={cn('badges px-2 py-1 rounded-full font-semibold', getTagBGColour(getLink(item)))}
                  >
                    <Link
                      id={index + randomNum + 'link'}
                      key={index + randomNum + 'link'}
                      title={item}
                      href={getLink(item)}
                    >
                      {item}
                    </Link>
                  </span>
                </li>
              ))}
          </ul>
        </div>
      </div>
    )
  }
  return ''
}

export default TooltipModel
